// extracted by mini-css-extract-plugin
export var attribution = "_ap-4";
export var authorName = "_ap-5";
export var quote = "_ap-3";
export var testimonial = "_ap-2";
export var trustedBy = "_ap-0";
export var trustedByLabel = "_ap-1";